module.exports = __webpack_public_path__ + "static/img/tdf-login.2316349.png";